import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoutesConst } from '../shared/route-const';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const isAuth = this.authService.authentication().isAuth;
    if (isAuth) return true;
    else {
      return this.router.createUrlTree(['/', RoutesConst.login], { queryParams: { returnUrl: state.url } });
    }
  }
}
